export default "__VITE_ASSET__CEeIKwXw__"